import { Collapse } from "antd"
import { observer } from "mobx-react-lite"
import { FC, useContext, useEffect, useState } from "react"
import { Context } from "../.."

import styles from "../../styles/Loyalty/LoyaltyStore.module.scss"
import XPageModal from "../../app/libs/topgun-ui-kit/xmodals/XPageModal"
import {Animator} from "../../app/libs/x-ui-animator/Animator"
import { createSupportFaqItems } from "./supportFaqItems"

// const listFAQ =  as CollapseProps['items']

const SupportModal: FC = () => {

  const { loyaltyStore } = useContext(Context)

  const [items, setItems] = useState([] as any[])

  useEffect(() => {
    if (loyaltyStore.isSupportVisible) {
      setItems(createSupportFaqItems({
        onOpenMobileApp: () => {
          loyaltyStore.setIsMAppVisible(true)
        },
      }))

      const animator = new Animator({
        timeline: [
          {point: 500, id: "supp1", styles: {opacity: "1"}},
          {point: 900, id: "supp2", styles: {opacity: "1", left: "0px"}},
          {point: 1100, id: "supp3", styles: {opacity: "1", left: "0px"}},
          {point: 1300, id: "supp4", styles: {opacity: "1", left: "0px"}},
          {point: 1500, id: "supp5", styles: {opacity: "1", left: "0px"}},
          {point: 1700, id: "supp6", styles: {opacity: "1", left: "0px"}},
          {point: 1900, id: "supp7", styles: {opacity: "1", left: "0px"}},
          // {point: 2200, id: "supp8", styles: {opacity: "1"}}
        ]
      })
  
      animator.run()
    } else {
      const animator = new Animator({
        timeline: [
          {point: 100, id: "supp1", styles: {opacity: "0"}},
          {point: 100, id: "supp2", styles: {opacity: "0", left: "-200px"}},
          {point: 100, id: "supp3", styles: {opacity: "0", left: "-200px"}},
          {point: 100, id: "supp4", styles: {opacity: "0", left: "-200px"}},
          {point: 100, id: "supp5", styles: {opacity: "0", left: "-200px"}},
          {point: 100, id: "supp6", styles: {opacity: "0", left: "-200px"}},
          {point: 100, id: "supp7", styles: {opacity: "0", left: "-200px"}},
          // {point: 100, id: "supp8", styles: {opacity: "0"}}
        ]
      })
  
      animator.run()
    }
  }, [loyaltyStore.isSupportVisible])

  return (
    <>
      <XPageModal
        id="support"
        visible={loyaltyStore.isSupportVisible}
        onClose={() => {
          loyaltyStore.setIsSupportVisible(false)
        }}
        activeZone={false}
        title={<><b className="xmtitle">Служба поддержки <strong>клиентов</strong></b></>}
        content={<>
          <div className={styles.objectively}>
            <h4 id="supp1" style={{opacity: "0", transition: "all 0.3s ease"}}>Часто задаваемые вопросы</h4>

            <Collapse defaultActiveKey={[]} ghost items={items} />

            {/* <p id="supp8" style={{
              textAlign: "center",
              marginTop: "32px",
              opacity: "0",
              transition: "all 0.3s ease"
            }}>
              <a href="#" onClick={(ev) => {
                prevent(ev)
                loyaltyStore.setIsSupportVisible(false)
                loyaltyStore.setIsRulesVisible(true)
              }}>Правила сервиса</a>
            </p> */}
          </div>
        </>} />
    </>
  )
}

export default observer(SupportModal)
